<div class="card h-full w-full">
  <p-tabs [value]="selectedTab?.title" (valueChange)="selectTab($any($event))">
    <p-tablist>
      @for (item of items; track item.label) {
        <p-tab [value]="item.label">{{ item.label }}</p-tab>
      }
    </p-tablist>
  </p-tabs>
  <div class="h-full w-full py-1">
    <ng-container *ngIf="selectedTab">
      <ng-container *ngComponentOutlet="selectedTab.component"></ng-container>
    </ng-container>
  </div>
</div>
